export default "__VITE_ASSET__6cf9a654__"